export default __webpack_public_path__ + "static/media/Brand of the Black Pharaoh.acc67453.jpg";